import React, { FC } from 'react';

import * as ST from './styled';

interface TProps {
    children?: JSX.Element | JSX.Element[],
    stepText: string,
    step?: string,
    subText?: string,
}

export const StepTitle: FC<TProps> = ({ children, stepText, step, subText })=> {

    return (
        <ST.TitleWrap>
            {children}
            <ST.StepText data-test={'step-text'}>
                {step && <ST.Step data-test={'step'}>{step} </ST.Step>}
                {stepText}
            </ST.StepText>
            {subText &&
                <ST.SubText data-test={'sub-text'}>
                    {subText}
                </ST.SubText>
            }
        </ST.TitleWrap>
    );
};
